import React from "react";
import { Modal, Row, Col, Carousel, Button, Checkbox } from "antd";
import chrome from "../images/browsers/chrome.png";
import edgeChromium from "../images/browsers/edge-chromium.png";
import firefox from "../images/browsers/firefox.png";
import safari from "../images/browsers/safari.png";
import encerrarStepmeet from "../images/browsers/encerrar-stepmeet4.png";

const CarouselAluno = ({ visibleBrowsers, confirmarEntrada, cancelarEntrada, selecionarNaoMostrar }) => {
    return (
        <>
            <Modal
                title="Informações sobre como deve aceder e/ou sair da Stepmeet"
                visible={visibleBrowsers}
                //okText="Confirmar"
                //onOk={confirmarEntrada}
                //onCancel={cancelarEntrada}
                //cancelText="Cancelar"
                maskClosable={false}
                className="modal-browsers"
                footer={[
                    <>
                        <div>
                            <Checkbox onClick={selecionarNaoMostrar}>Não mostrar mais esta mensagem</Checkbox>
                        </div>
                        <div>
                            <Button key="back" onClick={cancelarEntrada}>
                                Cancelar
                            </Button>
                            <Button key="submit" type="primary" onClick={confirmarEntrada}>
                                Confirmar
                            </Button>
                        </div>
                    </>
                ]}
            >
                <div className="body-modal-browsers">
                    <Carousel>
                        <div>
                            <div className="bloco-info-browsers">
                                <h3>Sair da Stepmeet</h3>
                                <div className="bloco-texto-imagem">
                                    <p>Para sair da stepmeet utilize o botão apresentado na imagem. Não encerre a sessão fechando o navegador.</p>
                                    <img src={encerrarStepmeet} />
                                </div>
                            </div>
                            <div className="bloco-info-separador"></div>
                            <div className="bloco-info-browsers">
                                <h3 style={{ marginBottom: 30 }}>Windows e Android (Browsers suportados):</h3>
                                <Row style={{ textAlign: "center" }}>
                                    <Col span={8}>
                                        <img src={edgeChromium} style={{ width: 60 }} />
                                    </Col>
                                    <Col span={8}>
                                        <img src={chrome} style={{ width: 60 }} />
                                    </Col>
                                    <Col span={8}>
                                        <img src={firefox} style={{ width: 60 }} />
                                    </Col>
                                </Row>
                            </div>
                            <div className="bloco-info-separador"></div>
                            <div className="bloco-info-browsers">
                                <h3 style={{ marginBottom: 30 }}>Mac, Ipad e Iphone (Browsers suportados):</h3>
                                <Row style={{ textAlign: "center" }}>
                                    <Col span={8}>
                                        <img src={safari} style={{ width: 60 }} />
                                    </Col>
                                </Row>
                            </div>
                            <div className="bloco-info-separador"></div>
                            <div className="bloco-info-browsers">
                                <h3>
                                    Verifique que tem as permissões ativas de microfone e camera no navegador para esta sessão.
                                    </h3>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </Modal>
        </>
    );
};

export default CarouselAluno;
